import { Injectable } from "@angular/core";
import { PrUtilityService } from "@irb/irb-editors/editor-portfolio-result/services/pr-utility.service";

@Injectable({
  providedIn: "root",
})
export class PrFormatService {
  constructor(private prutil: PrUtilityService) {}

  formatOutCome(val: string) {
    if (val === "NO_ORDERS") {
      return "No Orders";
    } else if (val === "CASH") {
      return "Cash";
    } else if (val === "REBALANCE") {
      return "Rebalance";
    } else if (val === "UNRESOLVED") {
      return "Unresolved";
    } else if (val === "ORDERS") {
      return "Orders";
    } 
    
    return val;
  }

  // NOT IN USE
  // formatCurrencyAndAppendSellTerm(inData: any, rowIndex: any) {
  //   console.log(inData, rowIndex);
  //   /*const amt = this.formatToIntegerData(inData);
  //   const ppsdOrderGrid = dijit.byId("proposedOrdersGrid");
  //   const currItem = ppsdOrderGrid.getItem(rowIndex);
  //   const sellTerm = ppsdOrderGrid.store.getValue(currItem, "sellTerm");
  //   sellTerm = sellTerm === null ? "" : sellTerm;
  //   const concatValue = amt + "<span>&nbsp;" + sellTerm + "</span>";
  //   return concatValue;*/
  // }
  //
  // formatAccountingAndAppendPenaltySymb(inData: any, rowIndex: any) {
  //   console.log(inData, rowIndex);
  //   /*const ppsdOrderGrid = dijit.byId("proposedOrdersGrid");
  //   const tradeItem = ppsdOrderGrid.getItem(rowIndex);
  //   const mayHaveChildren = ppsdOrderGrid.treeModel.mayHaveChildren(tradeItem);
  //   if (mayHaveChildren && inData != 0) {
  //     //only position level penalty is to be shown.
  //     const penaltyAmt = this.formatRounding(inData, 2);
  //     //if(penaltyAmt > 0){
  //     return "<span style='color:red'>" + penaltyAmt + "</span>";
  //     //}else{
  //     //penaltyAmt;
  //     //}
  //   } else {
  //     return "";
  //   }*/
  // }
  //
  // formatAccounting2(inData: number, place: number) {
  //   console.log(inData, place);
  //
  //   let returnValue = inData < 0 ? inData * -1 : inData;
  //
  //   if (!inData) {
  //     returnValue = 0;
  //   }
  //
  //   if (inData < 0) {
  //     //return "<span style='text-align: right; margin-right: 5%;'>$</span><span style='color:red;'>(" + dojo.number.format(returnValue, { places: place }) + ")</span>";
  //   } else {
  //     //return "<span style='text-align: right; margin-right: 5%;'>$</span><span style='text-overflow:ellipsis;overflow:hidden;text-align:right;'>" + dojo.number.format(returnValue, { places: place }) + "</span>";
  //   }
  // }

  formatAccounting(inData: number, place: number) {
    const roundedValue = this.prutil.roundDecNumber(inData, place);
    return this.addSymbol("$", roundedValue, inData);
  }

  formatAccountingNoSymb(inData: number, place: number) {
    if(inData) {
      const roundedValue = this.prutil.roundDecNumber(inData, place);
      return this.addSymbol("", roundedValue, inData);
    }
  }

  formatPercent(inData: number, decimalPoint: number) {
    /* IREBALUX-4242
     * We want to display two decimals instead of one, because users are allowed to specify % Min/Target/Max out to two decimals,
     * This is different than most other %'s throughout iRebal, which only allow one decimal.
     */
    decimalPoint = decimalPoint ? decimalPoint : 1;
    if (inData != null) {
      const roundedValue = this.prutil.roundDecNumber(inData, decimalPoint);
      return this.addSymbol("%", roundedValue, inData);
    }
  }
  
  formatPercent2(inData: number, decimalPoint: number) {
    /* IREBALUX-4242
     * We want to display two decimals instead of one, because users are allowed to specify % Min/Target/Max out to two decimals,
     * This is different than most other %'s throughout iRebal, which only allow one decimal.
     */
    decimalPoint = decimalPoint ? decimalPoint : 1;
    if (inData != null) {
      const roundedValue = this.prutil.roundDecNumber(inData, decimalPoint);
      return this.addSymbol("%", roundedValue, inData);
    }
  }
  
  formatPercentIfZero(val: number) {
    return val || "--";
  }

  // NOT IN USE
  // formatAsPercentOrExcluded(inData: number, rowIndex: number) {
  //   console.log(inData, rowIndex);
  //   /*//added to fix defect :155342 start
  //   const currentItem = dijit.byId("grid_allocationsGrid").getItem(rowIndex);
  //   const s = dijit.byId("grid_allocationsGrid").store;
  //   const secExclusionType = s.getValue(currentItem, "secExclusionType");
  //   const isExcludedPosition = secExclusionType === "OPTION" || secExclusionType === "SHORT" || secExclusionType === "EXCLUDED";
  //   //added to fix defect :155342 end
  //
  //   if (inData != null) {
  //     if (isExcludedPosition) {
  //       return getMouseTooltipWrapper("--", "Excluded");
  //     } else {
  //       const roundedValue = this.formatRounding(inData, 1);
  //       return this.addSymbol("%", roundedValue, inData);
  //     }
  //   }
  //   //added to fix defect :155342 start
  //   else {
  //     if (isExcludedPosition) {
  //       return getMouseTooltipWrapper("--", "Excluded");
  //     }
  //   }
  //   //added to fix defect :155342 end*/
  // }

  /**
   * @description Formats the given number to the given number of places
   * @param {Number} inData - The number to format.
   * @param {Number} place - The number of places.
   * @return {String} The formatted number.
   */
  formatRounding(inData: number, place: number) {
    if (!inData) {
      return 0;
    }

    if (place !== 0) {
      inData = this.prutil.roundDecNumber(inData, place);
    }

    //const roundedValue = dojo.number.format(inData, { places: place });
    //return roundedValue;
  }

  /**
   * @description Format the given number for the given symbol.
   * @param {String} symb - Optional, either $ or %.
   * @param {Number} data - the value to be formatted.
   * @param {Number} inData - the unmodified value.
   * @return {String} The value formatted with HTML.
   */
  addSymbol(symb: string, data: number, inData: number) {
    const dstr: string = data.toString().replace("-", "");

    switch (symb) {
      case "$":
        if (inData < 0) {
          return "<span style='float:left;'>$&nbsp;</span><span style='color:red;float:right;'>(" + dstr + ")</span>";
        } else {
          return "<span style='float:left;'>$&nbsp;</span><span style='text-overflow:ellipsis;overflow:hidden;float:right;'>" + dstr + "</span>";
        }
      case "%":
        if (inData < 0) {
          return "<span><span style='color:red;'>(" + dstr + ")</span>&nbsp;<span>%</span></span>";
        } else {
          return "<span style='text-overflow:ellipsis;overflow:hidden;text-align:right;'>" + dstr + "&nbsp;%</span>";
        }
      default:
        if (inData < 0) {
          return "<span><span style='color:red;'>(" + dstr + ")</span></span>";
        } else {
          return "<span style='text-overflow:ellipsis;overflow:hidden;text-align:right;'>" + dstr + "</span>";
        }
    }
  }

  /**
   * @description Formats and rounds the given number.
   * @param {Number} inData - Optional, the number to format.
   * @return {String} The number rounded and formatted with HTML.
   */
  formatToIntegerData(inData: number) {
    if (!inData) {
      return 0;
    }
    //const roundedValue = dojo.number.format(inData, { places: 0 });
    //return this.addSymbol("", roundedValue, inData);
  }
}
